<template>
  <SharedSnapshotBreadCrumbs
    v-if="sharedPage"
    :is-loading="isLoading"
  />
  <BreadCrumbsNavbar
    v-else
    :menu-pages="menuPagesWithPersistedParams"
    :is-loading="isLoading"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useAppPlatform } from '@/stores/app/platform';
import { useRoute } from 'vue-router';
import { getReportingQueryParam } from '@/api/helpers/insights/insights';
import BreadCrumbsNavbar from '@/components/shared/BreadCrumbsNavbar.vue';
import SharedSnapshotBreadCrumbs from '@/components/insights/SharedSnapshotBreadCrumbs.vue';
import { shareableInsights } from '@/helpers/constants/shareableInsights';

// Router
const route = useRoute();

defineProps({
  isLoading: { type: Boolean, default: false },
});

// Computed
const sharedPage = computed(() => shareableInsights.includes(route.name)
        && window.sessionStorage.reportingShareKey);

const menuPagesWithPersistedParams = computed(() => useAppPlatform().reportingNavLinks
  .map((menuPage) => ({
    ...menuPage,
    links: menuPage.links.map((link) => ({
      ...link,
      query: getReportingQueryParam(route, link.to),
    })),
  })));
</script>
